import { BaseIcon } from '../BaseIcon';
import type { BaseIconProps } from '../BaseIcon';

type StatusNotConnectedIconProps = Omit<BaseIconProps, 'children' | 'hasLegacyStrokeStyles'>;

export const StatusNotConnectedIcon = ({ strokeWidth, ...props }: StatusNotConnectedIconProps) => (
  <BaseIcon
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    strokeWidth={strokeWidth}
    title="Status Not Connected Icon"
    desc="A status icon representing a Profile to which you are not connected"
    {...props}
  >
    <rect width="20" height="20" fill="#AAAAAA" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6725 7.31527C11.2226 6.30645 11.6758 5.12397 12.6846 4.67412C13.6934 4.22428 14.8759 4.67741 15.3257 5.68623C15.7756 6.69504 15.3225 7.87752 14.3136 8.32737C13.3048 8.77722 12.1223 8.32408 11.6725 7.31527ZM12.2773 3.76081C10.7641 4.43558 10.0844 6.2093 10.7592 7.72253C11.434 9.23575 13.2077 9.91545 14.7209 9.24068C16.2341 8.56591 16.9138 6.79219 16.2391 5.27897C15.5643 3.76574 13.7906 3.08604 12.2773 3.76081ZM8.62329 11.3834C8.16526 10.9245 7.59559 10.6448 7.0015 10.5446L7.00556 6.43206C7.00583 6.15592 6.7822 5.93184 6.50605 5.93157C6.22991 5.93129 6.00583 6.15493 6.00556 6.43107L6.0015 10.5441C5.40816 10.6435 4.83892 10.9218 4.38065 11.3792C3.20792 12.5496 3.20605 14.4491 4.37647 15.6218C5.54688 16.7946 7.44638 16.7964 8.6191 15.626C9.79183 14.4556 9.79371 12.5561 8.62329 11.3834ZM5.08706 12.087C4.30524 12.8673 4.30399 14.1336 5.08427 14.9154C5.86455 15.6973 7.13088 15.6985 7.9127 14.9182C8.69451 14.1379 8.69576 12.8716 7.91549 12.0898C7.13521 11.308 5.86888 11.3067 5.08706 12.087Z"
      fill="white"
    />
  </BaseIcon>
);

StatusNotConnectedIcon.displayName = 'StatusNotConnectedIcon';
